export const DEFAULT_ZOOM_SIZE = 1;
export const DEFAULT_MIN_ZOOM_SIZE = 10;
export const ZOOM_SIZE_STEP = 10;
export const DEFAULT_MAX_ZOOM_SIZE = 200;
